import type { Task } from "../app/api/ApiClient";
import type { StateStore } from "../app/state/StateStore";

import type { Block } from "./Block";

export type BlockFactory = (
    task: Task,
    taskIndex: number,
    store: StateStore
) => Block;

/**
 * Реестр Block.
 *
 * Единственное место, где тип задания
 * сопоставляется с классом Block.
 */
export class BlockRegistry {

    private readonly registry =
        new Map<string, BlockFactory>();

    public register(
        taskType: string,
        factory: BlockFactory
    ): void {

        this.registry.set(
            taskType,
            factory
        );

    }

    public has(
            taskType: string
        ): boolean {

            return this.registry.has(
                taskType
            );

        }

    public create(

        task: Task,

        taskIndex: number,

        store: StateStore

    ): Block {

        const factory =
            this.registry.get(task.type);

        if (!factory) {

            throw new Error(
                `Block is not registered for "${task.type}".`
            );

        }

        return factory(
            task,
            taskIndex,
            store
        );

    }

}